export const HubSpotIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 28"
    fill="var(--icon-main, #f95c35)"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M19.61 20.18a3.77 3.77 0 0 1-3.78-3.75c0-2.07 1.7-3.75 3.78-3.75 2.1 0 3.8 1.68 3.8 3.75 0 2.07-1.7 3.75-3.8 3.75m1.14-10.96V5.88c.88-.4 1.5-1.29 1.5-2.31v-.08a2.58 2.58 0 0 0-2.6-2.56h-.07a2.58 2.58 0 0 0-2.6 2.56v.08c0 1.02.62 1.9 1.5 2.31v3.34c-1.3.2-2.5.73-3.5 1.52L5.75 3.62A2.9 2.9 0 0 0 2.93 0 2.9 2.9 0 0 0 0 2.89a2.9 2.9 0 0 0 4.36 2.5l9.1 7.01a7.22 7.22 0 0 0 .1 8.22l-2.76 2.74a2.39 2.39 0 0 0-3.09 2.27 2.39 2.39 0 0 0 2.4 2.37 2.38 2.38 0 0 0 2.3-3.05l2.73-2.71A7.4 7.4 0 0 0 27 16.43a7.33 7.33 0 0 0-6.25-7.21"
    />
  </svg>
);
